module.exports = __webpack_public_path__ + "img/people.678f5774.svg";